import { Alert, Tooltip, Typography } from '@mui/material';

export default function MadisonSystemInfoAlert() {
    return (
        <Tooltip title="Madison System - weight class not required">
            <Alert severity="info" variant="outlined" sx={{ paddingY: 0 }}>
                <Typography variant="caption">Madison System</Typography>
            </Alert>
        </Tooltip>
    );
}
